<template>
  <div class="auth-page w-100 position-absolute text-center bg-white" :style="{backgroundImage: `url(${require('@/assets/images/brief-bg.png')})`}">
    <b-container class="p-0 h-100" fluid>
      <b-row class="no-gutters register-inner h-100">
        <b-col cols="12" md="12" lg="5" class="px-3 order-2 order-lg-1">
          <div class="register-heading-wrapper text-left px-3 px-md-5" style="margin-top: 50px">
            <img :src="require('@/assets/icons/logo-dark.svg')" height="75" class="mt-2" alt="Agbeloba Logo" style="margin:30px 0" />
            <h4 class="register-heading font-weight-bold text-black-50 mt-2">Sign Up</h4>
            <p class="text-muted">Create an account to start</p>
            <!--<p class="text-muted">Register to attend Wealth Summit 2020</p>-->
          </div>
          <b-form @submit="submit" @input="formInput" class="text-left px-3 px-md-5" autocomplete="off">
            <b-row>
              <b-col cols="12" md="6" class="pr-lg-1">
                <b-form-group
                  :invalid-feedback="formErrors.firstname"
                  :state="fieldState.firstname"
                >
                  <b-input
                    id="firstname"
                    v-model="form.firstname"
                    placeholder="First Name"
                    :state="fieldState.firstname"
                    required
                    trim
                  ></b-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" class="pl-lg-1">
                <b-form-group :invalid-feedback="formErrors.lastname" :state="fieldState.lastname">
                  <b-input
                    id="lastname"
                    v-model="form.lastname"
                    placeholder="Last Name"
                    :state="fieldState.lastname"
                    required
                    trim
                  ></b-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group :invalid-feedback="formErrors.email" :state="fieldState.email">
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                required
                placeholder="Email Address"
                :state="fieldState.email"
                trim
              ></b-form-input>
            </b-form-group>
            <b-form-group
              :invalid-feedback="formErrors.phonenumber"
              :state="fieldState.phonenumber"
            >
              <b-form-input
                id="phonenumber"
                v-model="form.phonenumber"
                type="tel"
                required
                placeholder="Phone Number"
                :state="fieldState.phonenumber"
                trim
              ></b-form-input>
            </b-form-group>
            <b-form-group :invalid-feedback="formErrors.password" :state="fieldState.password">
              <div class="password-wrapper">
                <div
                  @click="doShowPassword()"
                  class="show-password btn position-absolute px-md-3 text-muted"
                  id="password-eye"
                  style="width:40px"
                >
                  <i v-if="!showPassword && !error" class="fa fa-eye"></i>
                  <i v-if="showPassword && !error" class="fa fa-eye-slash"></i>
                </div>
                <b-form-input
                  id="password"
                  v-model="form.password"
                  :type="passwordFieldType"
                  required
                  aria-describedby="password-help-block"
                  placeholder="Password"
                  :state="fieldState.password"
                ></b-form-input>
              </div>
            </b-form-group>
            <div
              v-if="referrerName != ''"
              class="wrapper bg-light mb-1"
              style="border-radius: 5px;"
            >
              <b-spinner class="mr-2" v-if="loadingReferrer" small label="Small Spinner"></b-spinner>
              <p class="d-inline" v-if="loadingReferrer">Searching for user...</p>
              <p
                class="m-0 p-0 d-inline"
                v-if="referrerName == null && !loadingReferrer"
              >Code doesn't belong to any referrer</p>
              <p class="m-0 p-0 d-inline" v-else>Referrer: {{ referrerName }}</p>
            </div>
            <b-form-group
              :invalid-feedback="formErrors.referrerscode"
              :state="fieldState.referrerscode"
            >
              <b-form-input
                autocomplete="off"
                id="referrerscode"
                v-model="form.referrerscode"
                @input="fetchReferrer"
                placeholder="Referral code or phone number (Optional)"
                :state="fieldState.referrerscode"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              :invalid-feedback="formErrors.acceptTerms"
              :state="fieldState.acceptTerms"
            >
              <b-form-checkbox
                :state="fieldState.acceptTerms"
                id="acceptTerms"
                v-model="form.acceptTerms"
                name="acceptTerms"
              >
                I accept the
                <a
                  target="_blank"
                  :href="`${backendURL}/terms-condition.html`"
                >terms and conditions</a>
              </b-form-checkbox>
            </b-form-group>
            <StatefulButton
              :error="error"
              :loading="submitting"
              text="Register"
              loadingText="Registering..."
              elementClass="w-100"
            />
          </b-form>
          <div class="user-utils pt-2">
            <div class="create-account mt-2">
              <h6 class="text-muted font-weight-normal">
                Already have an account?
                <router-link to="/login">Login</router-link>
              </h6>
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          md="12"
          lg="7"
          class="px-5 order-1 order-lg-2 align-items-start p-5 d-flex signup-ota bg-no-repeat planters"
           :style="{backgroundImage: `url(${require('@/assets/images/planters.png')})`}"
        >
             
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { appendNgCountryCode } from "@/utils/helpers";
import {
  validateRequired,
  checkFormErrors,
  validatePassword
} from "@/utils/validators";
import { AuthService } from "@/services";

import StatefulButton from "@/components/actions/StatefulButton.vue";

export default {
  name: "register",
  components: {
    StatefulButton
  },
  data() {
    return {
      logo: require("@/assets/icons/logo-light.svg"),
      wslogo: require("@/assets/images/wealthsummitlogo.png"),
      bgImage: `url(${require("@/assets/images/realvest1.jpg")})`,
      //bgImage: `url(${require("@/assets/images/wealthsummitbg.jpg")})`,
      wsImage: `url(${require("@/assets/images/wealthsummitlogo.png")})`,
      form: {
        firstname: "",
        lastname: "",
        email: "",
        phonenumber: "",
        password: "",
        referrerscode: "",
        acceptTerms: true
      },
      formErrors: {},
      referrerName: "",
      backendURL: "https://agbeloba.ng",
      passwordFieldType: "password",
      showPassword: false,
      error: false,
      submitting: false,
      searchTimeout: null,
      loadingReferrer: false
    };
  },
  methods: {
    ...mapActions("auth", ["register"]),

    async fetchReferrer() {
      this.referrerName = "";
      if (this.form.referrerscode.length < 1) return;
      clearTimeout(this.searchTimeout);
      const self = this;
      self.searchTimeout = setTimeout(async () => {
        self.loadingReferrer = true;
        const { name } = await AuthService.fetchReferrerViaCode(
          self.form.referrerscode
        );
        self.referrerName = name;
        self.loadingReferrer = false;
      }, 500);
    },

    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        await this.register(this.form);
        this.$router.replace({ name: "onboarding" });
      } catch (err) {
        this.formErrors = err;
        this.error = true;
        this.submitting = false;
      }
    },
    validateForm() {
      const {
        firstname,
        lastname,
        email,
        phonenumber,
        password,
        acceptTerms
      } = this.form;
      let { errors, valid } = validateRequired({
        firstname,
        lastname,
        email,
        phonenumber,
        password
      });
      if (!errors.password) {
        const res = validatePassword(password);
        errors.password = res.errors.password;
        valid = valid && res.valid;
      }
      if (!errors.phonenumber) {
        const res = this.validatePhoneNo(phonenumber);
        errors.phonenumber = res.errors.phonenumber;
        valid = valid && res.valid;
      }
      if (acceptTerms != true) {
        errors.acceptTerms = "Accept the terms to register";
        valid = false;
      }
      if (valid === false) throw errors;
    },

    validatePhoneNo(phonenumber) {
      let valid = true;
      const errors = {};
      phonenumber = appendNgCountryCode(phonenumber);
      const check = phonenumber.search(/^\+234(70|80|81|90)[0-9]{8}$/g);
      if (check === -1) {
        // errors["phonenumber"] = "Please enter a valid Nigerian phone number";
        // errors = {};
        valid = true;
      }
      //TODO: for future reference, Phone Number verfication was disabled
      return { errors, valid };
    },

    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    doShowPassword() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.showPassword = !this.showPassword;
    }
  },
  computed: {
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  }
};


</script>

<style lang="scss" scoped>

.signup-ota {
  background-position: right bottom;
}
.register-wrapper {
  height: fit-content;
  overflow: hidden;
  border-radius: 0px;
  width: 75vw;
  box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
}
.register-inner {
  height: 100%;
}
#password-eye {
  right: 4em;
}

.logo-text {
  text-shadow:0px 1px 1px #555;
  font-family: 'Roboto Slab', sans-serif;
  font-weight:800;
  font-size:70px;
  margin:40px 0
}

// Responsize styling

@media (max-width: 768px) {
  .btn {
    padding: 0.45rem 1.25rem;
  }
  .register-wrapper {
    border-radius: 4px;
    width: 100%;
    margin-bottom: 2em;
  }
  #password-eye {
    right: 3em;
  }
  .auth-page {
    // TODO: put a break point using height to get phones that are short
    height: -webkit-fill-available;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  // .register-inner {
  //   // height: 650px;
  // }
  .register-wrapper {
    border-radius: 4px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}

.register-welcome {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--primary);
    opacity: 0.6;
    width: 100%;
    height: 100%;
  }

  .video-wrapper {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
  }

  .videoWrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
    // width: 200px;
  }
  .videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  // .video-wrapper {
  // position: relative;
  // padding-bottom: 56.25%;
  // padding-top: 30px; height: 0; overflow: hidden;
  // }

  .video-wrapper iframe,
  .video-wrapper object,
  .video-wrapper embed {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    // height: auto;
  }
}



.show-video {
  animation: borderPulse 1000ms infinite ease-in-out;
}
/* Declare border pulse animation */
@keyframes borderPulse {
  0% {
    box-shadow: 0px 0px 0px 5px rgba(219, 98, 98, 0.4),
      0px 0px 0px 0px rgb(216, 127, 127);
  }
  100% {
    box-shadow: 0px 0px 0px 3px rgba(117, 117, 255, 0.2),
      0px 0px 0px 10px rgba(255, 255, 255, 0);
  }
}

@media screen and (max-width: 768px) {

    .planters {
         background-position:center; 
    }

    .mb-center {
      text-align:center !important
    }
    
}

@media screen and (min-width: 769px) {

    .planters {
       background-position:center
    }
    
}
</style>
